import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import * as tslib_1 from "tslib";
import { ApiClient, UiApiClient } from './ApiClient';
import { GetToken } from './commands/getToken';
import { accounts } from './commands/account';
import { GetAvailableFunds, GetBalances, GetBalancesForAccounts, GetBalancesForWithdrawal } from './commands/getBalances';
import { GetBars } from './commands/getBars';
import { GetMarketSchedule } from './commands/marketSchedule';
import { quotes } from './commands/quote';
import { GetSymbols, Symbols } from './commands/symbols';
import * as positions from './commands/positions';
import { options } from './commands/options';
import { history } from './commands/history';
import { ACH, Transfers, cashieringSearch, cashieringDetails, SecurityQuestion, cashieringDocuments, TransferInstructions, cashieringProfile, scheduledTransfers } from './commands/cashiering';
import { pnlHistory } from './commands/getPnLItem';
import { order } from './commands/orderApi';
import { Application } from './commands/application';
import { UserCommands } from './commands/userCommands';
import { auth } from './commands/auth';
import { info } from './commands/information';
import { AccManagement } from './commands/accountManagement';
import { Entitlements } from './commands/entitlements';
import { Downloads } from './commands/downloads';
import { GetBalanceHistory, HistoryGetBalances } from './commands/historyGetBalance';
import { subaccounts } from './commands/subaccounts';
import { twoFactorAuthentication } from './commands/twoFactorAuthentication';
export var TradingBlockAccountApi = function TradingBlockAccountApi(api, accountId, subaccountId) {
  var _this = this;

  _classCallCheck(this, TradingBlockAccountApi);

  this.order = function () {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", order(this.api)(this.accountId, this.subaccountId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.availableFunds = function () {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", GetAvailableFunds(this.api)(this.accountId, this.subaccountId));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.balances = function () {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", GetBalances(this.api)(this.accountId, this.subaccountId));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.positions = function () {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return positions.get(this.api)(this.accountId, this.subaccountId);

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
  };

  this.history = function (request) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", history.get(this.api)(Object.assign({}, request, {
                accountId: this.accountId
              })));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));
  };

  this.pnl = function (request) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", pnlHistory.get(this.api)(Object.assign({}, request, {
                accountId: this.accountId
              })));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));
  };

  this.availableWithdrawalFunds = function () {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", GetBalancesForWithdrawal(this.api)(this.accountId));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));
  };

  this.accountId = accountId;
  this.subaccountId = subaccountId;
  this.api = api;
};
export function TradingBlockApi(api) {
  return {
    auth: auth(api),
    accounts: accounts(api),
    accountManagement: AccManagement(api),
    balances: {
      get: GetBalances(api),
      getForAccounts: GetBalancesForAccounts(api),
      getForWithdrawals: GetBalancesForWithdrawal(api)
    },
    client: api,
    application: Application(api),
    getToken: GetToken(api),
    getBars: GetBars(api),
    getMarketSchedule: GetMarketSchedule(api),
    getSymbols: GetSymbols(api),
    cashiering: {
      ach: ACH(api),
      balances: GetBalances(api),
      securityQuestion: SecurityQuestion(api),
      transfers: Transfers(api),
      transferInstructions: TransferInstructions(api),
      search: cashieringSearch(api).search,
      details: cashieringDetails(api),
      documents: cashieringDocuments(api),
      profile: cashieringProfile(api),
      scheduledTransfers: scheduledTransfers(api)
    },
    history: {
      getBalanceHistory: GetBalanceHistory(api),
      getBalances: HistoryGetBalances(api)
    },
    downloads: Downloads(api),
    entitlements: Entitlements(api),
    information: info(api),
    order: order(api),
    options: options(api),
    quotes: quotes(api),
    symbols: Symbols(api),
    user: UserCommands(api),
    subaccounts: subaccounts(api),
    twoFactorAuthentication: twoFactorAuthentication(api)
  };
}
var tradingblockApis = {};
export function ApiFactory(rootUrl, authKey, onResponse, onResponseError) {
  if (tradingblockApis[rootUrl + authKey] !== undefined) {
    return tradingblockApis[rootUrl + authKey];
  }

  var tb_api = TradingBlockApi(new ApiClient(rootUrl, authKey).withResponseHandler({
    onResponse: onResponse,
    onResponseError: onResponseError
  }));
  tradingblockApis[rootUrl + authKey] = tb_api;
  return tb_api;
}
export function AccountApiFactory(rootUrl, authKey, accountId, subaccountId) {
  return new TradingBlockAccountApi(new ApiClient(rootUrl, authKey), accountId, subaccountId);
}
export function UiApiFactory(rootUrl, authKey) {
  return new UiApiClient(rootUrl, authKey);
}